import { OptionBank } from "../../ntuc/userService/staticData"
import { ValidatorBank } from "../validator"

enum BankAccountNumberError {
    WrongLength = `errors.invalid_bank_account`,
    NumbersOnly = `invalid_input`,
    InvalidBankAccountNumber = `errors.invalid_bank_account`
}

const MIN_LENGHT = 7
const MAX_LENGTH = 16

const validNumberLength = (input: string, noOfDigits: string): boolean => {
    const length = input.length

    // Split by comma for multiple conditions, e.g. "11, 12, 7-9"
    const conditions = noOfDigits.split(`,`).map(cond => cond.trim())

    for (const condition of conditions) {
        if (condition.includes(`-`)) {
            // Range condition ("7-9")
            const [min, max] = condition.split(`-`).map(Number)
            if (length >= min && length <= max && input.match(/^[0-9]*$/g)) return true
        } else {
            // Exact match ("11")
            const exact = Number(condition)
            if (length === exact && input.match(/^[0-9]*$/g)) return true
        }
    }
    return false

}

class BankAccountNumberValidator implements ValidatorBank<string, OptionBank, BankAccountNumberError> {
    validate(entry: string, bankDetail: OptionBank): BankAccountNumberError | undefined {
        if (bankDetail.noOfDigits !== null) {
            const isValidNumber = validNumberLength(entry, bankDetail.noOfDigits)
            if (!isValidNumber) {
                return BankAccountNumberError.InvalidBankAccountNumber
            }
        } else {
            if (entry.length < MIN_LENGHT || entry.length > MAX_LENGTH) {
                return BankAccountNumberError.WrongLength
            } else if (!entry.match(/^[0-9]*$/g)) {
                return BankAccountNumberError.NumbersOnly
            }
            return undefined
        }
    }
}

export { BankAccountNumberValidator }